import { DataTable } from '@/components/ui/data-table'
import { formatNumber, formatPercent } from '@/lib/format'
import type { IspStats } from '@/lib/types'

interface IspTableProps {
  data: IspStats[]
  isLoading: boolean
}

const ISP_COLUMNS = [
  {
    key: 'isp',
    label: 'ISP',
    sortable: true,
    render: (row: IspStats) => <span className="font-medium">{row.isp}</span>,
  },
  {
    key: 'volume',
    label: 'Volume',
    sortable: true,
    render: (row: IspStats) => formatNumber(row.volume),
  },
  {
    key: 'delivered_pct',
    label: 'Delivered %',
    sortable: true,
    render: (row: IspStats) => (
      <span className={row.delivered_pct < 90 ? 'font-medium text-danger' : 'text-text-primary'}>
        {formatPercent(row.delivered_pct)}
      </span>
    ),
  },
  {
    key: 'bounced_pct',
    label: 'Bounced %',
    sortable: true,
    render: (row: IspStats) => (
      <span className={row.bounced_pct > 5 ? 'font-medium text-danger' : 'text-text-primary'}>
        {formatPercent(row.bounced_pct)}
      </span>
    ),
  },
  {
    key: 'deferred_pct',
    label: 'Deferred %',
    sortable: true,
    render: (row: IspStats) => (
      <span className={row.deferred_pct > 10 ? 'font-medium text-warning' : 'text-text-primary'}>
        {formatPercent(row.deferred_pct)}
      </span>
    ),
  },
  {
    key: 'avg_delivery_ms',
    label: 'Avg Delivery',
    sortable: true,
    render: (row: IspStats) => `${row.avg_delivery_ms.toFixed(0)}ms`,
  },
]

export function IspTable({ data, isLoading }: IspTableProps): React.JSX.Element {
  return (
    <div>
      <h2 className="mb-3 text-sm font-medium text-text-primary">ISP Breakdown</h2>
      <DataTable<IspStats>
        columns={ISP_COLUMNS}
        data={data}
        isLoading={isLoading}
        emptyMessage="No ISP data for this period"
      />
    </div>
  )
}
